module.exports = __webpack_public_path__ + "img/ICS.84a1c9ab.svg";